import { NEXA_LOGO } from "../../data/content";
import { Countdown, DATE_SHORT } from "./Countdown";

const toForm = () => document.getElementById("register")?.scrollIntoView({ behavior: "smooth" });

export const StickyBar = () => (
  <div className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-[#EAECF0]" data-testid="sticky-bar">
    <div className="max-w-[1200px] mx-auto px-4 lg:px-6 h-16 flex items-center justify-between gap-4">
      <img src={NEXA_LOGO} alt="NEXA Mortgage" className="h-8 w-auto shrink-0" />
      <div className="hidden md:flex items-center gap-3 text-[13px] font-bold text-[#1D2939]">
        <span className="w-2 h-2 rounded-full bg-[#444CE7] animate-pulse" />
        <span data-testid="sticky-date">{DATE_SHORT}</span>
        <span className="text-[#98A2B3] font-normal">·</span>
        <span className="text-[#444CE7]"><Countdown compact /></span>
      </div>
      <button onClick={toForm} data-testid="sticky-cta-button"
        className="bg-[#444CE7] hover:bg-[#3538CD] text-white font-bold text-[13px] tracking-wide px-5 py-2.5 rounded-full transition-colors shrink-0">
        Save My Seat
      </button>
    </div>
  </div>
);

export const MobileBar = () => (
  <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white/95 backdrop-blur-md border-t border-[#EAECF0] p-3" data-testid="mobile-sticky-bar">
    <div className="flex items-center gap-3">
      <div className="text-[11px] font-bold text-[#1D2939] leading-tight shrink-0">
        <p>{DATE_SHORT}</p>
        <p className="text-[#444CE7]"><Countdown compact /></p>
      </div>
      <button onClick={toForm} data-testid="mobile-cta-button"
        className="flex-1 bg-[#444CE7] hover:bg-[#3538CD] text-white font-bold text-[14px] py-3 rounded-full transition-colors">
        Save My Seat
      </button>
    </div>
  </div>
);
